import {
  CLIENT_DETAILS,
  CLIENT_COLLATERALDATA,
  CLIENT_PEOPLESECTIONDATA,
  CLIENT_RELATEDASSETS,
  CLIENT_RESET_ADDITIONAL_DETAILS,
  SET_CLIENT_DETAILPAGE_RESULT,
  RESET_CLIENT_ISLOADING,
  CLIENT_ATTESTATION_INFO,CLIENT_ATTESTATION_RESULT
} from '../../constants/reducerTypes';

const initialState = { attestationInfo: { isloading: true }, attestationResult: null,isDataLoading: true};
const clientDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_DETAILS:
      return {
        ...state,
        ...action.payload.entity.dataProvider.detail,
      };
    case CLIENT_COLLATERALDATA:
      return {
        ...state,
        collaterals: action.payload,
      };
    case CLIENT_RELATEDASSETS:
      return {
        ...state,
        relatedAssets: action.payload,
      };
    case CLIENT_PEOPLESECTIONDATA:
      return {
        ...state,
        contacts: action.payload,
      };
    case SET_CLIENT_DETAILPAGE_RESULT:
      return {
        ...state,
        clientDetails: action.payload,
        isDataLoading: false,
      };
    case RESET_CLIENT_ISLOADING:
      return {
        ...state,
        isDataLoading: true,
      };
    case CLIENT_RESET_ADDITIONAL_DETAILS:
      return {
        ...state,
        relatedAssets: {},
        collaterals: [],
        contacts: [],
      };
    case CLIENT_ATTESTATION_INFO:
      return {
        ...state,
        attestationInfo: action.payload,
      };
    case CLIENT_ATTESTATION_RESULT:
      return {
        ...state,
        attestationInfo: {
          ...state.attestationInfo,
          isloading: false,
        },
        attestationResult: action.payload,
      };
    default:
      return state;
  }
};
export default clientDetailsReducer;
